var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForClients(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6693 14V12.6667C10.6693 11.9594 10.3883 11.2811 9.88822 10.781C9.38813 10.281 8.70985 10 8.0026 10H4.0026C3.29536 10 2.61708 10.281 2.11699 10.781C1.61689 11.2811 1.33594 11.9594 1.33594 12.6667V14",
    stroke: "#333333",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0026 7.33333C7.47536 7.33333 8.66927 6.13943 8.66927 4.66667C8.66927 3.19391 7.47536 2 6.0026 2C4.52984 2 3.33594 3.19391 3.33594 4.66667C3.33594 6.13943 4.52984 7.33333 6.0026 7.33333Z",
    stroke: "#333333",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6641 13.9998V12.6664C14.6636 12.0756 14.467 11.5016 14.105 11.0346C13.743 10.5677 13.2361 10.2341 12.6641 10.0864",
    stroke: "#333333",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6641 2.08643C11.2377 2.23329 11.7461 2.56689 12.1092 3.03463C12.4722 3.50237 12.6693 4.07765 12.6693 4.66976C12.6693 5.26187 12.4722 5.83715 12.1092 6.30489C11.7461 6.77262 11.2377 7.10623 10.6641 7.25309",
    stroke: "#333333",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForClients);
export default __webpack_public_path__ + "static/media/For Clients.43aed97340828febf8b7d65e826c5e9b.svg";
export { ForwardRef as ReactComponent };